import React from "react";

import classNames from "classnames";

import type { JSX } from "react";

interface LabelProps {
  label: string | JSX.Element;
  name: string;
  sublabel?: string | null;
  isRequired?: boolean;
  isCompact?: boolean;
  isFullWidth?: boolean;
  isStartLabel?: boolean;
}

export default function Label({
  label,
  sublabel,
  name,
  isFullWidth,
  isRequired,
  isCompact,
  isStartLabel = true,
}: LabelProps): JSX.Element {
  const labelClassNames = classNames(
    "mb-0 flex items-center whitespace-nowrap md:whitespace-normal",
    "font-medium",
  );

  const containerClassNames = classNames("flex shrink-0 grow-0 flex-col", {
    "basis-1/3 ": !isCompact,
    "self-start": isStartLabel,
    "self-center": !isStartLabel,
    "max-w-[256px]": isFullWidth,
  });

  return (
    <div className={containerClassNames}>
      <label className={labelClassNames} htmlFor={name}>
        {label}
        {isRequired ? <React.Fragment>&nbsp;*</React.Fragment> : null}
      </label>
      <span className="text-foreground">{sublabel}</span>
    </div>
  );
}
